import styled from 'styled-components';
import {getColorFromTheme} from '../../ui-utils';
import {Headline2} from '../../atoms/typography/headline2';
import {Headline4} from '../../atoms/typography/headline4';

export const Wrapper = styled.nav`
  display: block;
  position: absolute;
  right: 0;
  width: 272px;
  top: 120%;
  border-radius: 10px;
  border: solid 1px ${getColorFromTheme('borderLight')};
  background-color: ${getColorFromTheme('white')};

  box-shadow: ${({theme}) => theme.elevation.level1};
  z-index: 3;
`;

export const Footer = styled.footer`
  width: 100%;
  border-top: solid 1px ${getColorFromTheme('borderLight')};
  background-color: ${getColorFromTheme('backgroundLight')};
  padding-top: 8px;
  padding-bottom: 12px;
`;

export const Container = styled.div`
  width: 100%;
  padding: 20px 20px 12px;
`;

export const ProfileName = styled(Headline2)`
  font-size: 20px;
  line-height: 28px;
`;

export const Designation = styled(Headline4)`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 22px;
  vertical-align: middle;
`;

export const LoaderWrapper = styled.div`
  align-items: center;
  justify-content: center;
  min-height: 300px;
  display: flex;
`;
